import {Switch, SwitchProps} from "@material-ui/core";
import React from "react";
import styled from "styled-components/macro";

const Wrapper = styled.div`
  .MuiSwitch-root {
    padding: 8px;
  }
  
  .MuiSwitch-track {
    border-radius: 10px;
  }

  .Mui-checked + .MuiSwitch-track {
    opacity: unset;
    background-color: #E0E0E0 !important;
  }
  
  .Mui-checked .MuiSwitch-thumb {
    background: #86F8BD;
    box-shadow: 0 4px 7px rgba(0, 0, 0, 0.5);
  }
`

const GradientSwitch = (props: SwitchProps) => {
  return (
    <Wrapper>
      <Switch
        {...props}
      />
    </Wrapper>
  )
}

export default GradientSwitch